exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".agenda-row{cursor:pointer}.agenda-row:hover{background-color:#e2e2e2}\n", ""]);

